import Login from "../pages/Login/Login";
import { useAuth } from "../providers/auth";

export default function withAuth(props) {
  const Component = props;
  function AppWithAuth() {
    const { isAuth } = useAuth();

    return isAuth ? <Component /> : <Login />;
  }

  return AppWithAuth;
}
